/* ------------------------------ */
/* Load AddThis on Demand */

/* ------------------------------ */

window.addThisInit = function addThisInit() {
    if (typeof addthis === "undefined" && matchesMediaQuery(670)) {
        jQuery.getScript("//s7.addthis.com/js/300/addthis_widget.js#pubid=xa-5213218f34025191&domready=1");
    }
}